import {ChatBubbleLeftRightIcon, EyeIcon, HeartIcon, MapIcon} from '@heroicons/react/24/outline';

interface AccountStatsCardProps {
  tripsCount: number;
  totalComments: number;
  totalLikes: number;
  totalViews: number;
}

/**
 * Presentational component displaying traveler statistics.
 * Passport-style card with trips, comments, likes, and views.
 */
export const AccountStatsCard = ({
  tripsCount,
  totalComments,
  totalLikes,
  totalViews,
}: AccountStatsCardProps) => {
  return (
    <div className="bg-primary rounded-3xl shadow-2xl border border-brand p-6 text-on-dark overflow-hidden relative">
      <div className="absolute top-0 right-0 -mr-8 -mt-8 w-32 h-32 rounded-full bg-primary-dark opacity-50"></div>
      <div className="absolute bottom-0 left-0 -ml-8 -mb-8 w-24 h-24 rounded-full bg-primary-dark opacity-50"></div>
      <div className="relative z-10">
        <p className="text-on-brand text-sm  mb-4">Traveler Stats</p>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 text-center">
          <div className="flex flex-col items-center justify-center">
            <div className="flex items-center space-x-2">
              <MapIcon className="h-6 w-6 text-on-brand" />
              <p className="text-lg ">{tripsCount}</p>
            </div>
            <p className="text-xs text-on-brand mt-1">Trips</p>
          </div>
          <div className="flex flex-col items-center justify-center">
            <div className="flex items-center space-x-2">
              <ChatBubbleLeftRightIcon className="h-6 w-6 text-on-brand" />
              <p className="text-lg ">{totalComments}</p>
            </div>
            <p className="text-xs text-on-brand mt-1">Comments</p>
          </div>
          <div className="flex flex-col items-center justify-center">
            <div className="flex items-center space-x-2">
              <HeartIcon className="h-6 w-6 text-on-brand" />
              <p className="text-lg ">{totalLikes}</p>
            </div>
            <p className="text-xs text-on-brand mt-1">Likes</p>
          </div>
          <div className="flex flex-col items-center justify-center">
            <div className="flex items-center space-x-2">
              <EyeIcon className="h-6 w-6 text-on-brand" />
              <p className="text-lg ">{totalViews}</p>
            </div>
            <p className="text-xs text-on-brand mt-1">Views</p>
          </div>
        </div>
      </div>
    </div>
  );
};
